import {getVendorName, setVendorConsent} from './cmp-helpers';

const baseClass = 'cmp-placeholder';
const wrapperClass = `${baseClass}__wrapper`;
const innerClass = `${baseClass}__inner`;
const textClass = `${baseClass}__text`;


/**
 * @param {HTMLElement} parentElement
 * @param {string} vendor
 */
export async function addConsentPlaceholder(parentElement, vendor) {
  if (parentElement.classList.contains(wrapperClass)) {
    return;
  }

  parentElement.classList.add(wrapperClass);

  const vendorName = await getVendorName(vendor);

  const element = document.createElement('div');
  element.classList.add(innerClass);

  const text = document.createElement('div');
  text.classList.add(textClass);

  const paragraph = document.createElement('p');
  paragraph.innerText = `Wir benötigen Ihre Einwilligung`;

  const secondParagraph = paragraph.cloneNode(true);
  secondParagraph.innerText = `Dieser Inhalt wird von ${vendorName} bereit gestellt. Wenn Sie den Inhalt aktivieren, werden ggf. personenbezogene Daten verarbeitet und Cookies gesetzt.`;

  text.append(paragraph);
  text.append(secondParagraph);

  const acceptButton = document.createElement('button');
  acceptButton.classList.add('btn', 'btn-primary');
  acceptButton.innerText = `${vendorName} freigeben`;

  element.append(text);
  element.append(acceptButton);

  parentElement.append(element);

  acceptButton.addEventListener('click', () => {
    setVendorConsent(vendor, 3);
  });
}

/**
 * @param {HTMLElement} parentElement
 */
export function removeConsentPlaceholder(parentElement) {
  if (parentElement.classList.contains(wrapperClass) === false) {
    return;
  }

  parentElement.classList.remove(wrapperClass);

  for (const innerElement of [ ...parentElement.getElementsByClassName(innerClass) ]) {
    innerElement.remove();
  }
}
